module.exports = __webpack_public_path__ + "img/2T_510k_otc.f7af4876.jpg";